import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 25;

export const migration_24_25:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {component} = boxSnapshot;

                        if( component.name === 'Dropdown' )
                        {
                            const {componentDesc} = boxSnapshot;

                            Object.values(componentDesc._properties).forEach((propSnapshot:any) =>
                            {
                                if( propSnapshot.name === 'model' )
                                {
                                    setPlaceholderValue(propSnapshot._value);
                                    setChevronColorValue(propSnapshot._value);
                                    setAccentColorValue(propSnapshot._value);
                                    setPillValue(propSnapshot._value);

                                    setPlaceholderBindPaths(propSnapshot._bindGroups, designState.bindings);
                                    setChevronColorBindPaths(propSnapshot._bindGroups, designState.bindings);
                                    setAccentColorBindPaths(propSnapshot._bindGroups, designState.bindings);
                                    setPillBindPaths(propSnapshot._bindGroups, designState.bindings);
                                }
                            });
                        }
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function setPlaceholderValue(value:any)
{
    value.placeholder = {
        'text': value.placeholder,
        'visibility': value.placeholderVisibility,
        'font': {
            'typeface': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Helvetica Neue',
                'values': [
                    'Arial',
                    'Verdana',
                    'Times New Roman',
                    'Helvetica Neue'
                ]
            },
            'weight': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Regular',
                'values': [
                    'Thin',
                    'Light',
                    'Regular',
                    'Medium',
                    'Bold'
                ]
            },
            'color': {
                'hex': {
                    '__type': 'STRING',
                    'value': '#757575'
                },
                'alpha': {
                    '__type': 'NUMBER',
                    'value': 1
                }
            },
            'size': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 16
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'lineHeight': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 18
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'character': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 1
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'fontStyle': {
                '__type': 'BOOLEAN',
                'value': false
            },
            'decorationUnderline': {
                '__type': 'BOOLEAN',
                'value': false
            },
            'decorationCrossed': {
                '__type': 'BOOLEAN',
                'value': false
            }
        }
    };

    delete value.placeholderVisibility;
}

function setChevronColorValue(value:any)
{
    value.chevronColor = {
        'color': {
            'hex': {
                '__type': 'STRING',
                'value': '#000000'
            },
            'alpha': {
                '__type': 'NUMBER',
                'value': 0.37
            }
        },
        'visibility': {
            '__type': 'BOOLEAN',
            'value': true
        }
    };
}

function setAccentColorValue(value:any)
{
    value.accentColor = {
        'color': {
            'hex': {
                '__type': 'STRING',
                'value': '#4285f4'
            },
            'alpha': {
                '__type': 'NUMBER',
                'value': 1
            }
        },
        'visibility': {
            '__type': 'BOOLEAN',
            'value': true
        }
    };
}

function setPillValue(value:any)
{
    value.pill = {
        'font': {
            'typeface': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Helvetica Neue',
                'values': [
                    'Arial',
                    'Verdana',
                    'Times New Roman',
                    'Helvetica Neue'
                ]
            },
            'weight': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Regular',
                'values': [
                    'Thin',
                    'Light',
                    'Regular',
                    'Medium',
                    'Bold'
                ]
            },
            'color': {
                'hex': {
                    '__type': 'STRING',
                    'value': '#000000'
                },
                'alpha': {
                    '__type': 'NUMBER',
                    'value': 0.7
                }
            },
            'size': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 14
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'lineHeight': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 16
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'character': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 1
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'fontStyle': {
                '__type': 'BOOLEAN',
                'value': false
            },
            'decorationUnderline': {
                '__type': 'BOOLEAN',
                'value': false
            },
            'decorationCrossed': {
                '__type': 'BOOLEAN',
                'value': false
            }
        },
        'bgColor': {
            'color': {
                'hex': {
                    '__type': 'STRING',
                    'value': '#000000'
                },
                'alpha': {
                    '__type': 'NUMBER',
                    'value': 0.16
                }
            },
            'visibility': {
                '__type': 'BOOLEAN',
                'value': true
            }
        },
        'border': {
            'borderColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#000000'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 0
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'borderThickness': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 1
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'borderStyle': {
                '__type': 'STRINGENUM',
                'selectedValue': 'solid',
                'values': [
                    'solid',
                    'dashed'
                ]
            },
            'borderRadius': {
                'topLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 2
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'topRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 2
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 2
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 2
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                }
            },
            'borderFill': {
                '__type': 'STRINGENUM',
                'selectedValue': 'borderAll',
                'values': [
                    'borderLeft',
                    'borderTop',
                    'borderRight',
                    'borderBottom',
                    'borderAll'
                ]
            }
        },
        'removeButtonColor': {
            'color': {
                'hex': {
                    '__type': 'STRING',
                    'value': '#787b80'
                },
                'alpha': {
                    '__type': 'NUMBER',
                    'value': 1
                }
            },
            'visibility': {
                '__type': 'BOOLEAN',
                'value': true
            }
        }
    };
}

function setPlaceholderBindPaths(bindGroups:any, bindings:any)
{
    const mainBindGroup:any = Object.values(bindGroups).find((bindGroup:any) => bindGroup.name === 'main');

    const placeholderPath:any = Object.values(mainBindGroup.rootBindItem.paths[0])
        .find((item:any) => item.path === 'placeholder');
    const placeholderVisibilityPath:any = Object.values(mainBindGroup.rootBindItem.paths[0])
        .find((item:any) => item.path === 'placeholderVisibility');

    delete mainBindGroup.rootBindItem.paths[0][placeholderPath.id];
    delete mainBindGroup.rootBindItem.paths[0][placeholderVisibilityPath.id];

    if( placeholderPath.bindingId )
        bindings[placeholderPath.bindingId].path.fieldPath = 'placeholder.text';

    if( placeholderVisibilityPath.bindingId )
        bindings[placeholderVisibilityPath.bindingId].path.fieldPath = 'placeholder.visibility';

    mainBindGroup.rootBindItem.paths[0]['670be9f0-40b8-4059-a56c-f9eb04c9e1d6'] = {
        'id': '670be9f0-40b8-4059-a56c-f9eb04c9e1d6',
        'path': 'placeholder',
        'templatePath': 'placeholder',
        'paths': [
            {
                'cf8317b7-51bb-4679-9119-9ecfef7ec71e': {
                    'id': 'cf8317b7-51bb-4679-9119-9ecfef7ec71e',
                    'path': 'text',
                    'templatePath': 'placeholder.text',
                    'paths': null,
                    'bindingId': placeholderPath.bindingId
                },
                '4d410626-4e32-4829-af73-849a942ac499': {
                    'id': '4d410626-4e32-4829-af73-849a942ac499',
                    'path': 'visibility',
                    'templatePath': 'placeholder.visibility',
                    'paths': null,
                    'bindingId': placeholderVisibilityPath.bindingId
                },
                '0bb78951-8126-467e-af1a-fb8d7a2781ff': {
                    'id': '0bb78951-8126-467e-af1a-fb8d7a2781ff',
                    'path': 'font',
                    'templatePath': 'placeholder.font',
                    'paths': [
                        {
                            '91e40b97-604c-4673-8562-130762c9ecb3': {
                                'id': '91e40b97-604c-4673-8562-130762c9ecb3',
                                'path': 'typeface',
                                'templatePath': 'placeholder.font.typeface',
                                'paths': null,
                                'bindingId': null
                            },
                            '0a42aba6-d2f3-4548-a9d5-95bd0cc85e1f': {
                                'id': '0a42aba6-d2f3-4548-a9d5-95bd0cc85e1f',
                                'path': 'weight',
                                'templatePath': 'placeholder.font.weight',
                                'paths': null,
                                'bindingId': null
                            },
                            'e84a0bdd-9c86-4e89-900e-67ed3b3e9c8b': {
                                'id': 'e84a0bdd-9c86-4e89-900e-67ed3b3e9c8b',
                                'path': 'size',
                                'templatePath': 'placeholder.font.size',
                                'paths': [
                                    {
                                        '028fe4ef-be0c-42bf-b1de-949ff86c6bfd': {
                                            'id': '028fe4ef-be0c-42bf-b1de-949ff86c6bfd',
                                            'path': 'unitsString',
                                            'templatePath': 'placeholder.font.size.unitsString',
                                            'paths': null,
                                            'bindingId': null
                                        }
                                    }
                                ],
                                'bindingId': null
                            },
                            '1ec58d67-dcba-483d-b7f4-a25133d4e078': {
                                'id': '1ec58d67-dcba-483d-b7f4-a25133d4e078',
                                'path': 'lineHeight',
                                'templatePath': 'placeholder.font.lineHeight',
                                'paths': [
                                    {
                                        'ea90d07a-7e13-4190-9e34-2524ea96f246': {
                                            'id': 'ea90d07a-7e13-4190-9e34-2524ea96f246',
                                            'path': 'unitsString',
                                            'templatePath': 'placeholder.font.lineHeight.unitsString',
                                            'paths': null,
                                            'bindingId': null
                                        }
                                    }
                                ],
                                'bindingId': null
                            },
                            '910315ae-efaa-49dd-94c5-9d2a5ed5750b': {
                                'id': '910315ae-efaa-49dd-94c5-9d2a5ed5750b',
                                'path': 'character',
                                'templatePath': 'placeholder.font.character',
                                'paths': [
                                    {
                                        '81976fb9-d743-43d3-80f0-2fa65ff3c02d': {
                                            'id': '81976fb9-d743-43d3-80f0-2fa65ff3c02d',
                                            'path': 'unitsString',
                                            'templatePath': 'placeholder.font.character.unitsString',
                                            'paths': null,
                                            'bindingId': null
                                        }
                                    }
                                ],
                                'bindingId': null
                            },
                            '53997f7f-a484-431e-a658-02acf1d0d34b': {
                                'id': '53997f7f-a484-431e-a658-02acf1d0d34b',
                                'path': 'color',
                                'templatePath': 'placeholder.font.color',
                                'paths': [
                                    {
                                        'beb72145-d4b8-459d-b267-bcd05bb64102': {
                                            'id': 'beb72145-d4b8-459d-b267-bcd05bb64102',
                                            'path': 'hex',
                                            'templatePath': 'placeholder.font.color.hex',
                                            'paths': null,
                                            'bindingId': null
                                        },
                                        'e7120b18-66fa-479b-b2ed-bc017562fba6': {
                                            'id': 'e7120b18-66fa-479b-b2ed-bc017562fba6',
                                            'path': 'alpha',
                                            'templatePath': 'placeholder.font.color.alpha',
                                            'paths': null,
                                            'bindingId': null
                                        }
                                    }
                                ],
                                'bindingId': null
                            },
                            '25d6ec44-52ad-4a2f-a9f4-5c22c4a6652d': {
                                'id': '25d6ec44-52ad-4a2f-a9f4-5c22c4a6652d',
                                'path': 'fontStyle',
                                'templatePath': 'placeholder.font.fontStyle',
                                'paths': null,
                                'bindingId': null
                            },
                            '5a220c4c-6a19-4346-a408-6e4bc0f41a19': {
                                'id': '5a220c4c-6a19-4346-a408-6e4bc0f41a19',
                                'path': 'decorationUnderline',
                                'templatePath': 'placeholder.font.decorationUnderline',
                                'paths': null,
                                'bindingId': null
                            },
                            '5b7aa984-6053-429c-80fb-952463a19655': {
                                'id': '5b7aa984-6053-429c-80fb-952463a19655',
                                'path': 'decorationCrossed',
                                'templatePath': 'placeholder.font.decorationCrossed',
                                'paths': null,
                                'bindingId': null
                            },
                            '3081b168-5f57-43d7-9020-99ec02f0917f': {
                                'id': '3081b168-5f57-43d7-9020-99ec02f0917f',
                                'path': 'transformation',
                                'templatePath': 'placeholder.font.transformation',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                }
            }
        ],
        'bindingId': null
    };

}

function setChevronColorBindPaths(bindGroups:any, bindings:any)
{
    const mainBindGroup:any = Object.values(bindGroups).find((bindGroup:any) => bindGroup.name === 'main');

    mainBindGroup.rootBindItem.paths[0]['cb4499f2-908f-403e-832f-315ee3b1eb4c'] = {
        'id': 'cb4499f2-908f-403e-832f-315ee3b1eb4c',
        'path': 'chevronColor',
        'templatePath': 'chevronColor',
        'paths': [
            {
                '3d87398a-60a2-43d5-80d6-0ddc7c2930c5': {
                    'id': '3d87398a-60a2-43d5-80d6-0ddc7c2930c5',
                    'path': 'color',
                    'templatePath': 'chevronColor.color',
                    'paths': [
                        {
                            'b2498d0a-0bdf-44c9-8239-1ee8328e0794': {
                                'id': 'b2498d0a-0bdf-44c9-8239-1ee8328e0794',
                                'path': 'hex',
                                'templatePath': 'chevronColor.color.hex',
                                'paths': null,
                                'bindingId': null
                            },
                            '5684175e-0d1c-47f9-b463-6e5c3063f722': {
                                'id': '5684175e-0d1c-47f9-b463-6e5c3063f722',
                                'path': 'alpha',
                                'templatePath': 'chevronColor.color.alpha',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                },
                '7683d2e5-63b6-43ec-85b0-98f0693ca2e2': {
                    'id': '7683d2e5-63b6-43ec-85b0-98f0693ca2e2',
                    'path': 'visibility',
                    'templatePath': 'chevronColor.visibility',
                    'paths': null,
                    'bindingId': null
                }
            }
        ],
        'bindingId': null
    };
}

function setAccentColorBindPaths(bindGroups:any, bindings:any)
{
    const mainBindGroup:any = Object.values(bindGroups).find((bindGroup:any) => bindGroup.name === 'main');

    mainBindGroup.rootBindItem.paths[0]['d888348d-22a0-4a16-b89e-a70b86c0e1a9'] = {
        'id': 'd888348d-22a0-4a16-b89e-a70b86c0e1a9',
        'path': 'accentColor',
        'templatePath': 'accentColor',
        'paths': [
            {
                'e1156429-1852-468f-9717-286dbe53b381': {
                    'id': 'e1156429-1852-468f-9717-286dbe53b381',
                    'path': 'color',
                    'templatePath': 'accentColor.color',
                    'paths': [
                        {
                            'b1f115bc-31c7-47a2-a1bc-e8757556070d': {
                                'id': 'b1f115bc-31c7-47a2-a1bc-e8757556070d',
                                'path': 'hex',
                                'templatePath': 'accentColor.color.hex',
                                'paths': null,
                                'bindingId': null
                            },
                            '000ec15a-66a3-40e9-a472-eefe5337f4d4': {
                                'id': '000ec15a-66a3-40e9-a472-eefe5337f4d4',
                                'path': 'alpha',
                                'templatePath': 'accentColor.color.alpha',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                },
                '37168250-d648-48bb-85dd-0b5ee6815be4': {
                    'id': '37168250-d648-48bb-85dd-0b5ee6815be4',
                    'path': 'visibility',
                    'templatePath': 'accentColor.visibility',
                    'paths': null,
                    'bindingId': null
                }
            }
        ],
        'bindingId': null
    };
}

function setPillBindPaths(bindGroups:any, bindings:any)
{
    const mainBindGroup:any = Object.values(bindGroups).find((bindGroup:any) => bindGroup.name === 'main');
    const radiusEqualBindGroup:any = Object.values(bindGroups)
        .find((bindGroup:any) => bindGroup.name === 'radiusEqual');
    const radiusBindGroup:any = Object.values(bindGroups).find((bindGroup:any) => bindGroup.name === 'radius');

    mainBindGroup.rootBindItem.paths[0]['6565c031-d683-4107-9c50-1d1437803afc'] = {
        'id': '6565c031-d683-4107-9c50-1d1437803afc',
        'path': 'pill',
        'templatePath': 'pill',
        'paths': [
            {
                '0758d35d-f957-4e5c-8f7b-92d3f934394d': {
                    'id': '0758d35d-f957-4e5c-8f7b-92d3f934394d',
                    'path': 'font',
                    'templatePath': 'pill.font',
                    'paths': [
                        {
                            'b041ef89-03e1-4f26-9671-b4d0ac06367d': {
                                'id': 'b041ef89-03e1-4f26-9671-b4d0ac06367d',
                                'path': 'typeface',
                                'templatePath': 'pill.font.typeface',
                                'paths': null,
                                'bindingId': null
                            },
                            'cf60f8df-8b7c-4355-bda7-5727d3e6e4d9': {
                                'id': 'cf60f8df-8b7c-4355-bda7-5727d3e6e4d9',
                                'path': 'weight',
                                'templatePath': 'pill.font.weight',
                                'paths': null,
                                'bindingId': null
                            },
                            'f1616812-cda2-401e-a2d2-9048134c05c8': {
                                'id': 'f1616812-cda2-401e-a2d2-9048134c05c8',
                                'path': 'size',
                                'templatePath': 'pill.font.size',
                                'paths': [
                                    {
                                        '91738320-66fa-4c55-a014-db5806bfd2eb': {
                                            'id': '91738320-66fa-4c55-a014-db5806bfd2eb',
                                            'path': 'unitsString',
                                            'templatePath': 'pill.font.size.unitsString',
                                            'paths': null,
                                            'bindingId': null
                                        }
                                    }
                                ],
                                'bindingId': null
                            },
                            '8a8b3710-9208-413d-b0b1-97ea3ab5db03': {
                                'id': '8a8b3710-9208-413d-b0b1-97ea3ab5db03',
                                'path': 'lineHeight',
                                'templatePath': 'pill.font.lineHeight',
                                'paths': [
                                    {
                                        'b9c20531-a898-48f7-8d9c-562075f02197': {
                                            'id': 'b9c20531-a898-48f7-8d9c-562075f02197',
                                            'path': 'unitsString',
                                            'templatePath': 'pill.font.lineHeight.unitsString',
                                            'paths': null,
                                            'bindingId': null
                                        }
                                    }
                                ],
                                'bindingId': null
                            },
                            '72ef55fa-d56d-4b96-a47f-8f837e63100c': {
                                'id': '72ef55fa-d56d-4b96-a47f-8f837e63100c',
                                'path': 'character',
                                'templatePath': 'pill.font.character',
                                'paths': [
                                    {
                                        '4bbdef44-ad58-4e66-bfea-b33c550cc523': {
                                            'id': '4bbdef44-ad58-4e66-bfea-b33c550cc523',
                                            'path': 'unitsString',
                                            'templatePath': 'pill.font.character.unitsString',
                                            'paths': null,
                                            'bindingId': null
                                        }
                                    }
                                ],
                                'bindingId': null
                            },
                            '854b6c17-d883-41fd-8600-10935690216e': {
                                'id': '854b6c17-d883-41fd-8600-10935690216e',
                                'path': 'color',
                                'templatePath': 'pill.font.color',
                                'paths': [
                                    {
                                        'ac4ce3bf-eb51-4744-b059-3866cf492f8e': {
                                            'id': 'ac4ce3bf-eb51-4744-b059-3866cf492f8e',
                                            'path': 'hex',
                                            'templatePath': 'pill.font.color.hex',
                                            'paths': null,
                                            'bindingId': null
                                        },
                                        '4750ce59-61cb-43c9-a467-b535cefec664': {
                                            'id': '4750ce59-61cb-43c9-a467-b535cefec664',
                                            'path': 'alpha',
                                            'templatePath': 'pill.font.color.alpha',
                                            'paths': null,
                                            'bindingId': null
                                        }
                                    }
                                ],
                                'bindingId': null
                            },
                            'e33b7dd0-87be-4d12-86ee-e88162ec2585': {
                                'id': 'e33b7dd0-87be-4d12-86ee-e88162ec2585',
                                'path': 'fontStyle',
                                'templatePath': 'pill.font.fontStyle',
                                'paths': null,
                                'bindingId': null
                            },
                            '9e9a97fa-33d5-4e44-9fe5-cc40368a43d8': {
                                'id': '9e9a97fa-33d5-4e44-9fe5-cc40368a43d8',
                                'path': 'decorationUnderline',
                                'templatePath': 'pill.font.decorationUnderline',
                                'paths': null,
                                'bindingId': null
                            },
                            'fd332253-e4e0-4831-b361-72a928b86f7d': {
                                'id': 'fd332253-e4e0-4831-b361-72a928b86f7d',
                                'path': 'decorationCrossed',
                                'templatePath': 'pill.font.decorationCrossed',
                                'paths': null,
                                'bindingId': null
                            },
                            'be9098b9-8813-4673-9303-ee34313af6de': {
                                'id': 'be9098b9-8813-4673-9303-ee34313af6de',
                                'path': 'transformation',
                                'templatePath': 'pill.font.transformation',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                },
                'aa436a0b-e333-44a7-9d72-f5b32c288e75': {
                    'id': 'aa436a0b-e333-44a7-9d72-f5b32c288e75',
                    'path': 'bgColor',
                    'templatePath': 'pill.bgColor',
                    'paths': [
                        {
                            '695dd018-3482-483e-a3c9-36e4d0c184c5': {
                                'id': '695dd018-3482-483e-a3c9-36e4d0c184c5',
                                'path': 'color',
                                'templatePath': 'pill.bgColor.color',
                                'paths': [
                                    {
                                        '4bd2446e-3adc-4501-aebc-d65ec0ccc037': {
                                            'id': '4bd2446e-3adc-4501-aebc-d65ec0ccc037',
                                            'path': 'hex',
                                            'templatePath': 'pill.bgColor.color.hex',
                                            'paths': null,
                                            'bindingId': null
                                        },
                                        'eeb7d3b7-e826-434c-8246-dc1f94af55db': {
                                            'id': 'eeb7d3b7-e826-434c-8246-dc1f94af55db',
                                            'path': 'alpha',
                                            'templatePath': 'pill.bgColor.color.alpha',
                                            'paths': null,
                                            'bindingId': null
                                        }
                                    }
                                ],
                                'bindingId': null
                            },
                            '4d4a1a84-1c73-460d-8eec-24d766decd5e': {
                                'id': '4d4a1a84-1c73-460d-8eec-24d766decd5e',
                                'path': 'visibility',
                                'templatePath': 'pill.bgColor.visibility',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                },
                '53b7670c-8247-44bb-8d63-387bec63a03e': {
                    'id': '53b7670c-8247-44bb-8d63-387bec63a03e',
                    'path': 'border',
                    'templatePath': 'pill.border',
                    'paths': [
                        {
                            '38f0b6ac-6fdb-4757-b44e-8414cb120838': {
                                'id': '38f0b6ac-6fdb-4757-b44e-8414cb120838',
                                'path': 'borderColor',
                                'templatePath': 'pill.border.borderColor',
                                'paths': [
                                    {
                                        '6657c65a-f0f7-41d6-bc5a-3c4a582d30b6': {
                                            'id': '6657c65a-f0f7-41d6-bc5a-3c4a582d30b6',
                                            'path': 'color',
                                            'templatePath': 'pill.border.borderColor.color',
                                            'paths': [
                                                {
                                                    '3969db60-11de-4857-9389-31aab1af3f99': {
                                                        'id': '3969db60-11de-4857-9389-31aab1af3f99',
                                                        'path': 'hex',
                                                        'templatePath': 'pill.border.borderColor.color.hex',
                                                        'paths': null,
                                                        'bindingId': null
                                                    },
                                                    '4f393e59-23e0-47a3-9c69-bd967fac85f3': {
                                                        'id': '4f393e59-23e0-47a3-9c69-bd967fac85f3',
                                                        'path': 'alpha',
                                                        'templatePath': 'pill.border.borderColor.color.alpha',
                                                        'paths': null,
                                                        'bindingId': null
                                                    }
                                                }
                                            ],
                                            'bindingId': null
                                        },
                                        '5952cf2e-e740-4f85-82a1-3e4bfc658343': {
                                            'id': '5952cf2e-e740-4f85-82a1-3e4bfc658343',
                                            'path': 'visibility',
                                            'templatePath': 'pill.border.borderColor.visibility',
                                            'paths': null,
                                            'bindingId': null
                                        }
                                    }
                                ],
                                'bindingId': null
                            },
                            '3e609fc4-ea6d-4288-941e-14e0b69fd5af': {
                                'id': '3e609fc4-ea6d-4288-941e-14e0b69fd5af',
                                'path': 'borderThickness',
                                'templatePath': 'pill.border.borderThickness',
                                'paths': [
                                    {
                                        '4e8e7bce-977d-45b3-b6ce-e396550aee0c': {
                                            'id': '4e8e7bce-977d-45b3-b6ce-e396550aee0c',
                                            'path': 'unitsString',
                                            'templatePath': 'pill.border.borderThickness.unitsString',
                                            'paths': null,
                                            'bindingId': null
                                        }
                                    }
                                ],
                                'bindingId': null
                            },
                            '63c37ac4-bab6-4907-ba56-0191b051ffc4': {
                                'id': '63c37ac4-bab6-4907-ba56-0191b051ffc4',
                                'path': 'borderStyle',
                                'templatePath': 'pill.border.borderStyle',
                                'paths': null,
                                'bindingId': null
                            },
                            'e3795dc4-5505-454b-943e-c261774a0da4': {
                                'id': 'e3795dc4-5505-454b-943e-c261774a0da4',
                                'path': 'borderFill',
                                'templatePath': 'pill.border.borderFill',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                },
                '5bdff4e8-0784-4308-b0f9-fb5d5bd60471': {
                    'id': '5bdff4e8-0784-4308-b0f9-fb5d5bd60471',
                    'path': 'removeButtonColor',
                    'templatePath': 'pill.removeButtonColor',
                    'paths': [
                        {
                            'cf176144-c731-4ea2-a01b-e0ab42fa2548': {
                                'id': 'cf176144-c731-4ea2-a01b-e0ab42fa2548',
                                'path': 'color',
                                'templatePath': 'pill.removeButtonColor.color',
                                'paths': [
                                    {
                                        'dd38d38d-6315-4499-a5ae-345908e3f96d': {
                                            'id': 'dd38d38d-6315-4499-a5ae-345908e3f96d',
                                            'path': 'hex',
                                            'templatePath': 'pill.removeButtonColor.color.hex',
                                            'paths': null,
                                            'bindingId': null
                                        },
                                        'afd5ddfd-f02b-490b-aacf-bce6dfa9d3be': {
                                            'id': 'afd5ddfd-f02b-490b-aacf-bce6dfa9d3be',
                                            'path': 'alpha',
                                            'templatePath': 'pill.removeButtonColor.color.alpha',
                                            'paths': null,
                                            'bindingId': null
                                        }
                                    }
                                ],
                                'bindingId': null
                            },
                            '8b70dc74-c999-4a7c-bc55-68351414684c': {
                                'id': '8b70dc74-c999-4a7c-bc55-68351414684c',
                                'path': 'visibility',
                                'templatePath': 'pill.removeButtonColor.visibility',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                }
            }
        ],
        'bindingId': null
    };

    radiusEqualBindGroup.rootBindItem.paths[0]['ad32f2bf-fb74-48ab-b1b6-30bccaa4f3a8'] = {
        'id': 'ad32f2bf-fb74-48ab-b1b6-30bccaa4f3a8',
        'path': 'pill',
        'templatePath': 'pill',
        'paths': [
            {
                '4f7d78b1-eedf-44d1-af02-489dd09e7a80': {
                    'id': '4f7d78b1-eedf-44d1-af02-489dd09e7a80',
                    'path': 'border',
                    'templatePath': 'pill.border',
                    'paths': [
                        {
                            '487d05b3-a722-4604-828d-988e1c48336a': {
                                'id': '487d05b3-a722-4604-828d-988e1c48336a',
                                'path': 'borderRadius',
                                'templatePath': 'pill.border.borderRadius',
                                'paths': [
                                    {
                                        'b2bd2ae3-44ce-44cb-aaec-5c745a3db5f4': {
                                            'id': 'b2bd2ae3-44ce-44cb-aaec-5c745a3db5f4',
                                            'path': 'value',
                                            'templatePath': 'pill.border.borderRadius.value',
                                            'paths': null,
                                            'bindingId': null
                                        }
                                    }
                                ],
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                }
            }
        ],
        'bindingId': null
    };

    radiusBindGroup.rootBindItem.paths[0]['cfced2c3-8a9d-4fe7-861e-8314d87fd20a'] = {
        'id': 'cfced2c3-8a9d-4fe7-861e-8314d87fd20a',
        'path': 'pill',
        'templatePath': 'pill',
        'paths': [
            {
                '3fcbfc77-0ef6-48f2-aa8b-3f99baec69bc': {
                    'id': '3fcbfc77-0ef6-48f2-aa8b-3f99baec69bc',
                    'path': 'border',
                    'templatePath': 'pill.border',
                    'paths': [
                        {
                            '496baf61-f507-4b7d-881a-2a8e89815204': {
                                'id': '496baf61-f507-4b7d-881a-2a8e89815204',
                                'path': 'borderRadius',
                                'templatePath': 'pill.border.borderRadius',
                                'paths': [
                                    {
                                        '3ccceb26-036d-4e36-9f6b-25845c1b9001': {
                                            'id': '3ccceb26-036d-4e36-9f6b-25845c1b9001',
                                            'path': 'bottomLeft',
                                            'templatePath': 'pill.border.borderRadius.bottomLeft',
                                            'paths': null,
                                            'bindingId': null
                                        },
                                        'e474a831-4275-4c94-9d10-0cbda66bd32b': {
                                            'id': 'e474a831-4275-4c94-9d10-0cbda66bd32b',
                                            'path': 'bottomRight',
                                            'templatePath': 'pill.border.borderRadius.bottomRight',
                                            'paths': null,
                                            'bindingId': null
                                        },
                                        '21da8416-5b74-4158-b057-7fe47d05b388': {
                                            'id': '21da8416-5b74-4158-b057-7fe47d05b388',
                                            'path': 'topLeft',
                                            'templatePath': 'pill.border.borderRadius.topLeft',
                                            'paths': null,
                                            'bindingId': null
                                        },
                                        '10946e95-d338-405b-af7a-69b50464062b': {
                                            'id': '10946e95-d338-405b-af7a-69b50464062b',
                                            'path': 'topRight',
                                            'templatePath': 'pill.border.borderRadius.topRight',
                                            'paths': null,
                                            'bindingId': null
                                        }
                                    }
                                ],
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                }
            }
        ],
        'bindingId': null
    };
}
